import SpaceDetails from './SpaceDetails';
import SpaceDetailsCard from './components/SpaceDetailsCard/SpaceDetailsCard';

export { SpaceDetails, SpaceDetailsCard };
